import type { WorklogEvent } from './types';
import { fmtDuration, stripTag } from './format';

export function eventBodyText(e: WorklogEvent): string {
  if (e.event === 'note' || e.event === 'NOTE') return stripTag(e.note || '');
  if (e.event === 'link') {
    const note = stripTag(e.note || '');
    return note ? ((e.url || '') + '  -  ' + note) : (e.url || '');
  }
  if (e.event === 'task') return e.active_task || e.task || '';
  if (e.event === 'start') return 'Started: ' + (e.task || '');
  if (e.event === 'stop') return 'Stopped: ' + (e.task || '') + (e.duration_s ? '  (' + fmtDuration(e.duration_s) + ')' : '');
  if (e.event === 'pause') return 'Paused' + (e.reason ? ': ' + e.reason : '');
  if (e.event === 'resume') return 'Resumed' + (e.pause_duration_s ? '  (paused ' + fmtDuration(e.pause_duration_s) + ')' : '');
  if (e.event === 'subtract') return 'Subtracted ' + fmtDuration(e.subtracted_s || 0) + (e.reason ? '  -  ' + e.reason : '');
  if (e.event === 'ping') return 'Heartbeat' + (e.elapsed_s ? '  (' + fmtDuration(e.elapsed_s) + ' active)' : '');
  if (e.event === 'contract-start') return 'Contract started: ' + (e.contract || '');
  if (e.event === 'contract-end') return 'Contract ended: ' + (e.contract || '');
  if (e.event === 'item-status') {
    const reason = e.reason ? '  -  ' + e.reason : '';
    return (e.item || '?') + ' -> ' + (e.new_status || '?') + reason;
  }
  if (e.event === 'task-time') {
    return (e.item || '?') + ': ' + fmtDuration(e.seconds || 0) + ' attributed';
  }
  if (e.event === 'block') {
    const label = e.label ? e.label + ': ' : '';
    const itemPart = e.item ? '  -  ' + e.item : '';
    return label + fmtDuration(e.seconds || 0) + itemPart;
  }
  if (e.event === 'item-state') {
    return (e.item || '?') + (e.action ? ' (' + e.action + ')' : '');
  }
  if (e.event === 'unspecified-time') {
    return 'Unattributed: ' + fmtDuration(e.seconds || 0);
  }
  if (e.event === 'correct') {
    const origNote = e.original_note || '';
    const orig = origNote ? '  (was: ' + stripTag(origNote).slice(0, 60) + (origNote.length > 60 ? '...' : '') + ')' : '';
    return stripTag(e.note || '') + orig;
  }
  if (e.event === 'revise') {
    const titlePart = e.title ? '[' + e.title + ']  ' : '';
    const before = (e.before || '').replace(/\s+/g, ' ').trim();
    const after = (e.after || '').replace(/\s+/g, ' ').trim();
    return titlePart + before + '  ->  ' + after;
  }
  return e.event || '';
}
